import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        occurrence: '=',
        canManageOccurrences: '=',
        courseVersions: '=',
        course: '=',
        sites: '=',
        directManagers: '='
    },
    template: `
        <div class="well">
             <courses-courses-edit-occurrence-steps-general
                form="vm.form"
                occurrence="vm.occurrence"
                can-manage-occurrences="vm.canManageOccurrences"
                course-versions="vm.courseVersions"
                course="vm.course"
                direct-managers="vm.directManagers"
                sites="vm.sites"
                context="'add'"
            />
        </div>
    `
})
export default class {
    constructor (FormFactory) {
        this.form = this.occurrence.id ?
            FormFactory.create(this.occurrence, model => model.$update({ id: model.id,
                expand: 'courseOccurrenceParticipants,courseVersion,courseOccurrenceLanguages,courseOccurrenceManagers,sites' })) :
            FormFactory.create(this.occurrence, model => model.$save());
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/add/general/index.js